import React, { useEffect } from "react";
import "./App.css";
import Editor from "./components/Editor";
import Previewer from "./components/Previewer";
import Header from "./components/Header";
import "./tailwind.output.css";

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://cdn.freecodecamp.org/testable-projects-fcc/v1/bundle.js";
    document.body.appendChild(script);
    script.async = true;
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="App h-full min-h-screen bg-indigo-200 flex flex-col">
      <Header />
      <div className="flex flex-1 justify-around">
        <Editor />
        <Previewer />
      </div>
    </div>
  );
}

export default App;
